<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-13 16:44:19
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-07 15:36:29
 * @Description: 待办事项
-->
<template>
  <div class="home-pending-items">
    <!-- 首页功能模块共用组件 -->
    <func-module
      title="待办事项"
      icon="icon-red-daiban"
      titleColor="#12dae2"
      rowColor="#ECFAFF"
      :tips="pendingTips"
      :showNum="5"
      :listData="data.list"
      @handlePublish="handlePublish"
      @intoDetail="handleViewClick"
      @hanleViewAll="getAllPendingItems(priorityCode.all)"
    >
      <template #toDo>
        <div class="welcome-text" v-if="data.list.length >= 0">
          {{ userShare.name }}，您尚有
          <span v-if="getUnFinishTotal">
            {{ getUnFinishTotal }}
          </span>
          <span v-else>0</span>
          个未处理的待办事项
        </div>
      </template>
      <template #row="{item}">
        <div class="row">
          <div class="row-left">
            <i class="icon-red-daiban iconfont"></i>
            <div class="row-left-title">
              <span v-if="item.isRead == '0'" style="font-weight: bold;">{{
                item.title
              }}</span>
              <span v-else style="color: #8e9093;white-space: nowrap;">{{
                item.title
              }}</span>
            </div>
          </div>

          <div class="row-middle">
            <span v-if="item.isRead == '0'" style="font-weight: bold;">{{
              item.content | filterContext
            }}</span>
            <span v-else style="color: #8e9093;white-space: nowrap;">{{
              item.content | filterContext
            }}</span>
          </div>
          <!--          <div class="row-middle" v-else>-->
          <!--            <span v-if="item.isRead == '0'" style="font-weight: bold">{{-->
          <!--              item.content-->
          <!--                .toString()-->
          <!--                .substring(0, item.content.toString().indexOf("&lt;span"))-->
          <!--            }}</span>-->
          <!--            <span v-else style="color: #8e9093;white-space: nowrap;">{{-->
          <!--              item.content-->
          <!--                .toString()-->
          <!--                .substring(0, item.content.toString().indexOf("&lt;span"))-->
          <!--            }}</span>-->
          <!--          </div>-->

          <div class="row-right">
            <span v-if="item.isRead == '0'" style="font-weight: bold">{{
              item.createTm | dateFormat
            }}</span>
            <span v-else style="color: #8e9093;white-space: nowrap;">{{
              item.createTm | dateFormat
            }}</span>
          </div>
        </div>
      </template>
    </func-module>

    <common-dialog
      width="40%"
      :visible.sync="dialog.isShow"
      v-loading="dialog.isLoading"
      class="spec-dialog"
      @close="handleCloseDialog"
    >
      <div class="dialog-title" slot="title">
        <template>
          <div>{{ dialog.form.title }}</div>
        </template>
      </div>
      <div class="dialog-body" style="font-size: 16px;line-height: 30px">
        <div class="pending-time">
          {{ dialog.form.createTm | dateFormat }}
        </div>
        <p class="pending-content" v-html="dialog.form.content"></p>
      </div>
      <div class="dialog-footer" slot="footer">
        <common-button
          v-if="showConfirm"
          type="primary"
          style="margin-left:10px"
          @click="hanleConfirmFinish"
        >
          确认
        </common-button>
        <common-button type="cancel" @click="dialog.isShow = false">
          取消
        </common-button>
      </div>
    </common-dialog>

    <el-dialog
      :visible.sync="edited.editedDialogFlag"
      @close="handleCloseeditedDialog"
      min-width="430px"
      width="430px"
    >
      <div class="dialog-title" slot="title">
        新用户信息详情
      </div>
      <el-form label-width="110px" size="small">
        <el-form-item label="用户名:">
          <span class="dialog-content-span">{{ edited.name }}</span>
        </el-form-item>
        <el-form-item label="注册机构:">
          <span class="dialog-content-span">{{ edited.majorDepartName }}</span>
        </el-form-item>
        <el-form-item label="关联机构:" size="small" style="font-weight: 500;">
          <el-cascader
            ref="editDeptCascader"
            :props="{ checkStrictly: true }"
            :options="departments"
            :show-all-levels="false"
            @change="handleApproveDeptChange"
            clearable
            filterable
            style=""
          >
          </el-cascader>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <common-button
          @click="handleCommitDialog('1')"
          size="small"
          type="primary"
          style="text-align: center"
          >同意</common-button
        >
        <common-button
          @click="handleCommitDialog('0')"
          size="small"
          type="cancel"
          style="text-align: center"
          >拒绝</common-button
        >
      </template>
    </el-dialog>

    <PostCreate
      @sensitiveWord="sensitiveWord"
      ref="forum-create"
      :base-url="baseUrl"
      title="发布待办事项"
      :visible.sync="pendingCreateVisible"
      :has-attachment="false"
      :has-members="true"
      :has-draft-btn="false"
      priority-tp-code="008-003"
      content-type="待办事项"
      :tips="pendingTips"
      @refresh="queryData"
    />

    <animation
      :loadingDataVisible="loadingDataVisible"
      :loadingText="loadingText"
    ></animation>
  </div>
</template>

<script>
import { mapState } from "vuex";
import cookie from "../../utils/cookie";
import http from "../../utils/axios";
import Animation from "../loading/animation";
import { Message } from "element-ui";
import FuncModule from "@/components/common/FuncModule";
import PostCreate from "../detail/PostCreate.vue";

export default {
  name: "PendingItemsComponent",
  components: { PostCreate, Animation, FuncModule },
  data() {
    return {
      //true是结束,false是正在处理
      loadingDataVisible: false,
      pendingCreateVisible: false,

      loadingText: "",
      priorityCode: {
        all: "0",
        urgent: "008-001",
        secondary: "008-002",
        ordinary: "008-003"
      },
      data: {
        list: []
      },
      dialog: {
        isShow: false,
        isLoading: false,
        form: []
      },
      edited: {
        editedDialogFlag: false,
        name: "",
        majorDepartName: "",
        provinceName: "",
        cityName: "",
        departmentId: null,
        isApprv: "",
        rejectReason: "",
        userId: ""
      },
      addDepartment: {
        addDialogFlag: false
      },
      departments: [],
      selectedDepartTp: null,
      baseUrl: "/eims-api/toDoList/publishTodo"
    };
  },

  mounted() {
    this.$store.dispatch("getUnreadTotal");
    this.$store.dispatch("getUserInfo");
    this.queryData();
    window.showApproveDialog = this.showApproveDialog;
    this.getDepartments();
  },

  methods: {
    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {
          items();
        })
        .catch(_ => {});
    },

    handlePublish() {
      this.pendingCreateVisible = true;
    },

    showApproveDialog() {
      this.edited.editedDialogFlag = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/user/approve/list", {
          token: cookie.getCookie("token"),
          data: {
            userId: this.dialog.form.eventReferenceId
          }
        })
        .then(response => {
          let eimsUser = response.data.data.eimsUserList[0];
          this.edited.userId = eimsUser.userId;
          this.edited.name = eimsUser.name;
          this.edited.majorDepartName = eimsUser.majorDepartName;
          this.edited.majorDepartName = eimsUser.majorDepartName;
          this.edited.provinceName = this.getProvinceNameMethod(
            eimsUser.provinceCode
          );
          this.edited.cityName = this.getCityNameMethod(eimsUser.cityCode);
        })
        .finally(() => {});
    },

    getProvinceNameMethod(value) {
      for (let arr in this.eimsCodes) {
        if (this.eimsCodes[arr].cd == value) {
          return this.eimsCodes[arr].cdDesc;
        }
      }
      return "";
    },
    getCityNameMethod(value) {
      for (let arr in this.eimsCodes) {
        if (this.eimsCodes[arr].cd == value) {
          return this.eimsCodes[arr].cdDesc;
        }
      }
      return "";
    },

    handleApproveDeptChange(value) {
      if (this.$refs.editDeptCascader.getCheckedNodes()[0] !== undefined) {
        this.selectedDepartTp = this.$refs.editDeptCascader.getCheckedNodes()[0].data.tp;
      } else {
        this.selectedDepartTp = null;
      }
      this.$refs.editDeptCascader.dropDownVisible = false;
      this.edited.departmentId = value[value.length - 1];
    },

    handleCloseeditedDialog() {
      this.edited.editedDialogFlag = false;
      this.edited.name = "";
      this.edited.majorDepartName = "";
      this.edited.departmentId = null;
      this.edited.userId = "";
      this.edited.isApprv = "";
      this.edited.rejectReason = "";
      this.edited.provinceName = "";
      this.edited.cityName = "";
      this.selectedDepartTp = null;
      this.$refs.editDeptCascader.handleClear();
    },
    handleCommitDialog(isApprv) {
      let _this = this;
      if (isApprv == "1" && !_this.edited.departmentId) {
        Message.error({ message: "关联机构不能为空！", showClose: true });
        return;
      }
      if (isApprv == "1" && _this.selectedDepartTp < 5) {
        Message.error({
          message: "关联机构只能选择医院和科室！",
          showClose: true
        });
        return;
      }
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/user/approve", {
          token: token,
          data: {
            userId: _this.edited.userId,
            isApprv: isApprv,
            departmentId: _this.edited.departmentId,
            rejectReason: ""
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            Message.success({ message: "审核成功", showClose: true });
            _this.handleCloseeditedDialog();
            _this.queryData();
            this.dialog.isShow = false;
          }
        });
    },

    getDepartments() {
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/department/findCurrentAndSub",
          {
            token: token,
            data: {
              pageSize: -1
            }
          }
        )
        .then(response => {
          this.departments = response.data.data.departments;
        });
    },

    getAllPendingItems(priority) {
      this.$router.push({ path: "/pendingItems/list" });
      this.$store.dispatch("preservePriority", priority);
    },

    //查询列表
    queryData() {
      let _this = this;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/toDoList/list", {
          token: token,
          data: {
            title: "",
            isFinish: "0",
            priority: "0"
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            _this.data.list = response.data.data.eimsTodoList;
          }
        })
        .finally(() => {});
    },

    handleViewClick(row) {
      if (
        row.postTpCode != null &&
        (this.superPower || this.deptPower || this.systemPower)
      ) {
        this.queryArticle(row);
      } else {
        this.dialog.isShow = true;
        this.dialog.form = row;
        this.changeToRead(row);
      }
    },

    //关闭弹窗
    handleCloseDialog() {
      this.dialog.isShow = false;
    },
    //更新状态为已读
    changeToRead(row) {
      let _this = this;
      _this.loadingDataVisible = false;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/toDoList/changeStatus", {
          token: token,
          data: {
            id: row.id
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            this.queryData();
            this.dialog.form = row;
          }
        })
        .finally(() => {
          //更新未读数量
          this.$store.dispatch("getUnreadTotal");
        });
    },
    //查看文章状态是否发生变化
    queryArticle(row) {
      let _this = this;
      _this.loadingDataVisible = false;
      let token = cookie.getCookie("token");
      let content = row.content;
      _this.changeToRead(row);
      http
        .post(window.config.api.baseUrl + "/eims-api/share/approve/findById", {
          token: token,
          data: {
            postCode: content.substring(
              content.indexOf("code=") + 5,
              content.indexOf('"target="')
            ),
            tpCode: row.postTpCode
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            //判断文章不存在或者文章状态发生变化
            if (response.data.data.responseStr) {
              Message.warning(response.data.data.responseStr);
              return false;
            }
            _this.dialog.isShow = true;
            _this.dialog.form = row;
          } else {
            return false;
          }
        })
        .finally(() => {});
    },
    hanleConfirmFinish() {
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/toDoList/finishToDoList", {
          token: token,
          data: {
            id: this.dialog.form.id
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            this.queryData();
          }
        })
        .finally(() => {
          this.dialog.isShow = false;
        });
    }
  },

  watch: {
    getUnFinishTotal: {
      immediate: true,
      handler(newval, oldval) {
        this.queryData();
      }
    }
  },

  computed: {
    getHelloText() {
      // 获取当前小时
      let hours = new Date().getHours();
      // 设置默认文字
      let helloText = "";
      // 判断当前时间段
      if (hours >= 0 && hours <= 11) {
        helloText = "早上好！";
      } else if (hours > 11 && hours <= 14) {
        helloText = "中午好！";
      } else if (hours > 14 && hours <= 18) {
        helloText = "下午好！";
      } else if (hours > 18 && hours <= 24) {
        helloText = "晚上好！";
      }
      return helloText;
    },
    showConfirm() {
      return !this.dialog.form.eventType || this.dialog.form.eventType === "4";
    },
    ...mapState({
      urgentTotal: state => state.pendingItemListModule.urgentTotal,
      secondaryTotal: state => state.pendingItemListModule.secondaryTotal,
      ordinaryTotal: state => state.pendingItemListModule.ordinaryTotal,
      unreadTotal: state => state.pendingItemListModule.unreadTotal,
      getUnFinishTotal: state => state.pendingItemListModule.getUnFinishTotal,
      userShare: state => state.userModule.userShare,
      latestLoginRcrd: state => state.userModule.latestLoginRcrd,
      superPower: state => state.userPowerStore.superPower,
      systemPower: state => state.userPowerStore.systemPower,
      deptPower: state => state.userPowerStore.deptPower
    })
  }
};
</script>

<style lang="scss" scoped>
.home-pending-items {
  border-radius: 8px;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 100%;
  .row {
    display: flex;
    align-items: center;
    .row-left {
      display: flex;
      width: 40%;
      padding-right: 20px;
      .row-left-title {
        font-size: 15px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .icon-red-daiban {
        color: #41bef0;
        font-size: 20px;
        padding: 0 10px;
      }
    }
    .row-middle {
      width: 39%;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .row-right {
      font-size: 14px;
      width: 20%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .welcome-text {
    font-size: 16px;
    padding: 5px 0 0 30px;
  }
  .dialog-body {
    height: 300px;
    overflow: auto;
  }

  .dialog-footer > button {
    float: right;
  }

  .pending-content {
    text-indent: 2em;
    clear: both;
  }

  .pending-time {
    font-size: 15px;
    float: right;
    color: #9e9e9f;
    margin-bottom: 10px;
  }
  .pending-head {
    background-image: url(../../../static/images/bgimage.png);
    background-size: cover;
    background-color: #12dae2;
  }

  a {
    cursor: pointer;
  }
}

/deep/ .add-dept-dialog .el-dialog__header {
  padding: unset;
}
/deep/ .add-dept-dialog .el-dialog__body {
  padding: unset;
}
/deep/ .el-dialog__footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/home/PendingItemsComponent.vue